"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTranslationsCustomization = exports.TranslationsCustomizationContextProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var wrapDisplayName_1 = require("../../react/wrapDisplayName");
var flowRight_1 = tslib_1.__importDefault(require("lodash/flowRight"));
var TranslationsCustomizationContext = react_1.default.createContext(undefined);
TranslationsCustomizationContext.displayName = "TranslationsCustomizationContext";
var TranslationsCustomizationIsLoadingContext = react_1.default.createContext(undefined);
TranslationsCustomizationIsLoadingContext.displayName = "TranslationsCustomizationIsLoadingContext";
/**
 * @beta
 */
exports.TranslationsCustomizationContextProvider = function (_a) {
    var children = _a.children, translationsCustomizationIsLoading = _a.translationsCustomizationIsLoading, translations = _a.translations;
    return (react_1.default.createElement(TranslationsCustomizationContext.Provider, { value: translations },
        react_1.default.createElement(TranslationsCustomizationIsLoadingContext.Provider, { value: translationsCustomizationIsLoading }, children)));
};
function withTranslationsCustomizationValue(Component) {
    var ComponentWithInjectedTranslationsCustomizationValue = function (props) {
        return (react_1.default.createElement(TranslationsCustomizationContext.Consumer, null, function (translations) { return react_1.default.createElement(Component, tslib_1.__assign({ translations: translations }, props)); }));
    };
    return wrapDisplayName_1.wrapDisplayName("withTranslationsCustomizationValue", exports.TranslationsCustomizationContextProvider)(ComponentWithInjectedTranslationsCustomizationValue);
}
function withTranslationsCustomizationIsLoading(Component) {
    var ComponentWithInjectedTranslationsCustomizationIsLoading = function (props) {
        return (react_1.default.createElement(TranslationsCustomizationIsLoadingContext.Consumer, null, function (translationsCustomizationIsLoading) { return (react_1.default.createElement(Component, tslib_1.__assign({ translationsCustomizationIsLoading: translationsCustomizationIsLoading }, props))); }));
    };
    return wrapDisplayName_1.wrapDisplayName("withTranslationsCustomizationIsLoading", exports.TranslationsCustomizationContextProvider)(ComponentWithInjectedTranslationsCustomizationIsLoading);
}
/**
 * @beta
 */
function withTranslationsCustomization(Component) {
    return flowRight_1.default(wrapDisplayName_1.wrapDisplayName("withTranslationsCustomization"), withTranslationsCustomizationValue, withTranslationsCustomizationIsLoading)(Component);
}
exports.withTranslationsCustomization = withTranslationsCustomization;
//# sourceMappingURL=Context.js.map